import unit from './unit';

export default function diopter(value, decimals = 2) {
  return unit(value, 'D', decimals);
}
